import React from "react";
import type { McpChatMessage } from "../shared/mcp-chat-types";

interface McpChatSuggestionsProps {
  messages: McpChatMessage[];
  isLoading: boolean;
  inputValue: string;
  onSuggestionClick: (suggestion: string) => void;
}

const McpChatSuggestions: React.FC<McpChatSuggestionsProps> = ({
  messages,
  isLoading,
  inputValue,
  onSuggestionClick
}) => {
  if (messages.length === 0 || isLoading || inputValue.trim() !== "") return null;

  // Find the last assistant message
  let lastAssistant: McpChatMessage | undefined;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === "assistant" && !messages[i].isError) {
      lastAssistant = messages[i];
      break;
    }
  }

  if (
    !lastAssistant ||
    lastAssistant.isStreaming ||
    !lastAssistant.suggestions ||
    lastAssistant.suggestions.length === 0 ||
    lastAssistant.interruptData?.status === "pending"
  ) {
    return null;
  }

  return (
    <div className="mcp-chat__suggestions">
      {lastAssistant.suggestions.slice(0, 3).map((suggestion, idx) => (
        <button
          key={idx}
          className="mcp-chat__suggestion-chip"
          style={{ "--chip-index": idx } as React.CSSProperties}
          onClick={() => onSuggestionClick(suggestion)}
          title={suggestion}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default McpChatSuggestions;
